const uiTextData = {
	//‑ non-breaking hyphen
	bg: {
		global: {
			loading: "Зареждане...",
			log_out: "Изход",
			log_out_confirm: "Сигурни ли сте, че искате да излезете от профила си?",
			time: {
				second: "сек",
				second_long: "секунда",
				seconds_long: "секунди",
				minute: "мин",
				minute_long: "минута",
				minutes_long: "минути",
				hour: "ч",
				hour_long: "час",
				hours_long: "часа",
				day: "д",
				day_long: "ден",
				days_long: "дни",
			},
			distance: {
				meter: "м",
				meters: "м",
				kilometer: "км",
				kilometers: "км",
			},
			standalone: {
				title: "Моля, отвори сайта в стандартен браузър.",
				description:
					"Възможно e някои от функциите на системата да не работят коректно. За по-добро изживяване, отвори сайта в браузър, например Google Chrome.",
			},
		},
		login: {
			title: "Нека започнем твоето приключение!", //Let's start your adventure!
			by_log_pre:
				"Но първо - моля, влез в системата. Влизайки се съгласяваш с нашата ",
			by_log_title: "Политика за поверителност",
			by_log_post: ".",
			by_log_link: "/privacy",
			no_mission_strong: "Все още нямаш мисия?",
			no_mission_pre: " Разгледай",
			no_mission_title: "нашите мисии",
			no_mission_post: " и открий най-добрата за теб!",
			no_mission_link: "/games",
			withGoogle: "Влез с Google",
			anonymous: "Влез анонимно",
			terms_pre: "Прочетох и съм съгласен с ",
			terms_title: "Общите условия",
			terms_post: ", в това число и правилата за безопасност.",
			terms_link: "/terms",
			postrules_next: "Продължи напред",

			new_team: "Създай отбор",
			join_team: "Присъедини се",

			anon_new_name: "Ново име",
			anon_new_image: "Ново изображение",
			anon_confirm: "Потвърди и продължи",
			anon_back: "Назад",

			recaptcha_pre: "Ако не виждате нашата ",
			recaptcha_name: "reCAPTCHA",
			recaptcha_post: " по-горе, ",
			recaptcha_getintouch: "пишете ни",
			recaptcha_end: ".",
		},
		new_join: {
			enter_game_code: "Въведи код на играта",
			game_code_description:
				"Ще го откриеш в мейла си или на картата на играта.",
			game_code_placeholder: "ABCD1234",

			enter_session_code: "Въведи код на сесията",
			session_code_description: "Ще го откриеш при създателя на сесията.",
			session_code_placeholder: "Qu357",

			enter_team_name: "Въведи име на отбора",
			team_name_description: "Как ще се казва този супер отряд?",
			team_name_placeholder: "Име на отбора",

			next: "Напред",
			back: "Назад",
			join: "Присъедини се",
			surrender: "Откажи се",
			copy_code: "Копирай",
			code_copy: "Кодът е копиран!",

			invite_more:
				"Можеш да поканиш още хора да се включат в отбора с ключа отгоре.",
			invite_no_more: "Не могат да се присъединят повече играчи.",

			make_sure:
				"Увери се, че твоите съотборници са се присъединили и сте на началната локация, преди за започнеш играта.",

			start_game: "Започни игра",
			start_game_confirm:
				"Увери се, че твоите съотборници са се присъединили и сте на началната локация, преди за започнеш играта. Да започваме ли?",
			leave_session: "Напусни сесията",
			starting_location: "Начална точка",

			surrender_title: "Отказ?",
			surrender_multiple_leave_description:
				'Използвай това САМО, ако всички в играта желаят да се откажат. Ако САМО ти искаш да напуснеш играта, използвай бутона "Напусни сесията".',
			surrender_multiple_surrender_description:
				"Ако всички желаете да се откажете, въведете името на отбора си по-долу.",
			surrender_single_gameover_description:
				"Ти си единственият играч в играта. Ако се откажеш, играта е автоматично загубена. Не се притеснявай да продължиш по-късно, ако нямаш възможност сега.",
			surrender_single_surrender_description:
				"Ако си сигурен, че желаеш да се откажеш - въведи името на отбора си по-долу.",
		},
		tutorial: {
			intro: "Ето едно кратко въведение, за да знаеш какво те очаква.",
			expand: "Разгъни",
		},
		tutorial_overlay: {
			skip: "Пропусни въведението",
			next: "Напред",
			previous: "Назад",
			none: {
				title: "Преди да започнеш игра",
				subtitle: "ето кратко въведение в игралната система",
				page_contains: "Страницата се състои от няколко основни компонента - ",
				strong1: "загадката",
				comma: ", ",
				strong2: "полето за отговор",
				and: " и ",
				strong3: "насоките",
				if: ", ако има такива.",
				strong4: "Загадката",
				page_contains2:
					" съдържа информация къде трябва да отидеш и какво трябва да откриеш там, за да продължиш напред.",
			},
			riddle: {
				title: "Загадката",
				subtitle: "е основната част на страницата",
				each_riddle:
					"Всяка загадка се намира на нова локация, затова първо разбери къде трябва да отидеш, за да я разрешиш успешно.",
				once_there:
					"Щом си на правилното място - огледай се внимателно край себе си - само така ще успееш да откриеш отговора.",
			},
			input: {
				title: "Полето за въвеждане",
				subtitle: "ще откриеш в долната част",
				some_enough:
					"За някои загадки ще е достатъчно да въведеш числа или думи, за да продължиш напред. Други загадки може да изискват да изброиш няколко отговора.",
				some_exceptional:
					"При някои загадки полето за отговор липсва - вместо това трябва правилно да подредиш пъзел, да въведеш символи или да сканираш QR код например.",
			},
			hints: {
				title: "Има и насоки",
				subtitle: "на някои от загадките",
				cost: "Те обаче може да ти костват точки от финалния резултат, затова помисли преди да ги използваш.",
				slide: "За да отключиш насока, приплъзни ключето към катинарчето.",
			},
			header: {
				title: "Освен това",
				subtitle: "най-горе имаш 3 бутона",
				xmark:
					"Можеш да използваш този, ако искаш да напуснеш играта или целият отбор се отказва.",
				question:
					"Ако насоките не помагат или имаш нужда от допълнителна информация - тук ще откриеш нашите контакти.",
				language:
					"По всяко време можеш да смениш и езика на игралната система, без това да промени езика на играта.",
			},
			footer: {
				title: "Най-долу пък",
				subtitle: "ще откриеш кода за присъединяване",
				invite:
					"С него можеш да поканиш да се включат към отбора ти още играчи, дори след като вече е започната игра.",
			},
			all: {
				title: "Това е всичко!",
				subtitle: "Приключението те очаква.",
				lets_go: "Да започваме!",
			},
		},
		message: {
			google_login_error:
				"Възникна грешка при опит за влизане с Google. Моля опитайте отново по‑късно.",
			game_inactive_error: "Играта не е активна в настоящия момент.",
			game_not_found_error: "Не е открита игра с този код.",
			new_game_created_check:
				"Успешно е създадена нова сесия. Покани съотборници с кода от екрана или продължи сам.",
			game_already_over_error: "Съжаляваме, играта вече е приключила.",
			activation_code_used_error:
				"Този код вече е бил използван от друг потребител.",
			activation_code_used_can_join_error:
				"Този код вече е бил използван от друг потребител, но все още можеш да се присъединиш - попитай ги за ключ за присъединяване.",
			activation_code_use_limit_error:
				"Този код вече е достигнал ограничението за брой употреби.",
			player_limit_error:
				"Достигнат е лимитът на играчите. Не могат да се присъединят нови играчи.",
			default_error: "Възникна грешка. Код на грешката - ",
			default_error_end: "Не е открита сесия с такъв код за присъединяване. Моля, проверете главни и малки букви в кода. Ако не стане - обновете страницата и опитайте отново.",
			default_okay: "Разбрах",
		},
		game: {
			skippable_riddle_title: "Тази загадка може да бъде пропусната",
			skippable_riddle_description:
				"Ако имаш технически затруднения с изпълнението на тази загадка, можеш да я пропуснеш.",
			skippable_riddle_skip: "Пропусни загадката",
			skippable_riddle_skip_confirmation:
				"Сигурен ли си, че искаш да пропуснеш загадката?",
			skippable_riddle_skip_message: "Загадката е пропусната.",
			// —
			bonus_riddle_title: "Честито, откри бонус загадка!",
			bonus_riddle_description:
				"Бонус загадките са по‑сложни загадки без насоки. Няма да загубиш точки, ако решиш да я пропуснеш.",
			bonus_riddle_skip: "Пропусни загадката",
			bonus_riddle_skip_confirmation:
				"Сигурен ли си, че искаш да пропуснеш бонус загадката?",
			bonus_riddle_skip_message: "Бонус загадката е пропусната.",
			header: {
				surrender_title: "Отказ",
				help_title: "Помощ",
				lang_title: "Смяна на език",
			},
			aside: {
				button: "Въведи",
				button_check: "Провери",
				button_reset: "Занули",
				button_backspace: "Изтрий",
				answer_revealed: "Разкрит отговор",
				answer_hidden: "Неразкрит отговор",
				has_hints: "Тази загадка има насоки.",
				has_hints_description:
					"Използването на насоки може да ви коства точки.",
				slide_to_unlock: "Плъзни ключа до катинара, за да разкриеш насоката.",
				hint_confirmation:
					"Сигурен ли си, че искаш да отвориш насока?\nИзползването на насоки може да ви коства точки.",
			},
			riddle: {
				multiple_all_message: "Добра работа! Готови за следващата загадка?",
				multiple_all_action: "Напълно!",
				multiple_more_message:
					"Супер си! Можеш ли да откриеш следващия отговор?", //"Correct! Let's find the next answer.",
				multiple_more_action: "Мога!",
				multiple_repeat_message:
					"Този отговор е правилен. Толкова правилен, дори, че вече сме го чували.",
				multiple_repeat_action: "Ще опитам отново!",
				multiple_wrong_message:
					"Готов или не - този отговор не води никъде... 😭",
				multiple_wrong_action: "Нека пробваме отново!",
				single_message: "Супер! Готови за следващата загадка?",
				single_action: "Напред!",
				wrong_message: "Ох.. не знам как да го кажа... това е грешно 😢",
				wrong_action: "Ще опитам пак! 💪",
				default_action: "Добре", //Default Okay [193],
				could_not_locate:
					"Не успяхме да открием настоящата загадка в системата. Моля, свържете се с администратор.",
				not_too_fast:
					"Не толкова бързо! Прочети загадката внимателно и тогава изпробвай отговори.",
			},
			qr: {
				scan_btn: "Сканирай QR код",
				qr_camera_disclaimer:
					"Необходимо е разрешение за използване на камерата. Информацията от камерата ти не напуска твоето устройство и не се съхранява никъде.",
			},
			geolocked: {
				this_part: "Тази част е географски заключена.",
				visit_correct: "Отиди до правилното място, за да я отключиш.",

				you_unlocked: "Успешно отключи тази част.",
				stay_around: "Остани наблизо, за да не се заключи отново.",

				permission: "Използвай местоположението ми",
				disclaimer:
					"Необходимо е разрешение за използване на твоето местоположение. Информацията за местоположението ти не напуска твоето устройство и не се съхранява никъде.",
				tracking: "Проследяване...",
				your_distance: "Намираш се на ",
				from_target: " от целта.",
				closer_unlock: "Приближи се, за да отключиш.",
				error: "Възникна грешка!",
				error_timeout: "Заявката не успя да се изпълни за очакваното време.",
				error_permission:
					"Липсва разрешение за използване на местоположението.",
				error_unavailable: "Местоположението не може да бъде установено.",
				error_browser: "Геолокацията не се поддържа от този браузър.",
			},
			footer: {
				vendor: "Вътрешен глас",
				powered_by: "Задвижвано от",
				join_code: "Код за присъединяване:",
			},
		},
		chat: { send: "Изпрати", type_message: "Напиши съобщение...", send_image: "Изпрати изображение", chat_header_title: "Чат", sending: 'Изпраща се...', uploaded_by: "Качено от ", input_disabled: 'Изпращането на съобщения е изключено.' },

		help: {
			title: "Имаш нужда от помощ?",
			description: "Не се притеснявай да се свържеш с нас:",
			messenger: "Facebook Messenger",
			messenger_link: "https://m.me/vutreshenglas",
			instagram: "Instagram",
			instagram_link: "https://instagram.com/vutreshenglas",
			email: "zdrasti@vutreshenglas.com",
			email_link: "mailto:zdrasti@vutreshenglas.com",
		},
		conclusion: {
			share_how_to_be_better: "Сподели как да бъдем по‑добри.",
			send_review: "Изпрати отзив",
			send_review_link:
				"mailto:zdrasti@vutreshenglas.com?subject=Отзив за игра",
			back_home: "Назад към началото",
			sorry_pre: "Съжаляваме, ",
			sorry_post: ", изглежда играта те надви.",
			sorry_description: "Повече късмет следващия път!",
			congrats_pre: "Браво, ",
			congrats_post: "! Ти завърши играта!",
			congrats_description: "Справяш се супер със загадките, поздравления.",

			your_time: "Твоето време",
			your_hints: "Използвани насоки",
			your_score: "Твоят резултат",
			time: "Време",
			hints: "Насоки",
			used_hint: "използванa насокa",
			used_hints: "използвани насоки",
			score: "Резултат", //или Точки
			point: "точка",
			points: "точки",
			see_leaderboard: "Виж класирането",
			share_your_score: "Сподели своя резултат",
			download_share: "Свали и сподели",
			completed_the_mission: "завърши мисията",
			generating: "Генериране ...",
		},
		map: {
			map_header_title: "Карта",
			//
			error_no_browser_support: "Геолокацията не се поддържа от този браузър.",
			error_permission_denied:
				"Възникна грешка - отказано разрешение за използване на геолокация.",
			error_position_unavailable:
				"Възникна грешка - информацията за местоположението е недостъпна.",
			error_timeout:
				"Възникна грешка - заявката за получаване на местоположението на потребителя е просрочена.",
			error_uknown_error:
				"Възникна непозната грешка - местоположението не може да бъде установенo.",
			error_generic:
				"Възникна грешка - местоположението не може да бъде установенo.",
			//
			outside_of_play_area: "Намирате се извън игровата зона.",
			go_east: "Моля, насочете се на изток.",
			go_west: "Моля, насочете се на запад.",
			go_north: "Моля, насочете се на север.",
			go_south: "Моля, насочете се на юг.",
			go_se: "Моля, насочете се на югоизток.",
			go_sw: "Моля, насочете се на югозапад.",
			go_ne: "Моля, насочете се на североизток.",
			go_nw: "Моля, насочете се на северозапад.",
		},
		panel: {
			scan_qr_pre: "Сканирай кода, за да се включиш в",
			scan_qr_post: "и играй с приятели!"
		},

		// order: {
		//     success: {
		//         page_title: 'УСПЕХ!',
		//         title: 'Here comes the title in BG',
		//         content_md: 'Check your email for your game code and begin your adventure on [vutreshenglas.com/igrai bace](https://vutreshenglas.com/game).'
		//     },
		//     cancel: {
		//         page_title: 'ОТКАЗ',
		//         title: 'Here comes the title in BG',
		//         content_md: 'Check your email for your game code and begin your adventure on [vutreshenglas.com/game](https://vutreshenglas.com/game).'
		//     }

		// }
	},
	en: {
		global: {
			loading: "Loading...",
			log_out: "Log out",
			log_out_confirm: "Are you sure you want to log out?",
			time: {
				second: "s",
				second_long: "second",
				seconds_long: "seconds",
				minute: "m",
				minute_long: "minute",
				minutes_long: "minutes",
				hour: "h",
				hour_long: "hour",
				hours_long: "hours",
				day: "d",
				day_long: "day",
				days_long: "days",
			},
			distance: {
				meter: "m",
				meters: "m",
				kilometer: "km",
				kilometers: "km",
			},
			standalone: {
				title: "Please, open the site in a standard browser.",
				description:
					"Some of the system functions may not work correctly. For a better experience, open the site in a standard browser such as Google Chrome.",
			},
		},
		login: {
			title: "Let's start your adventure!", //
			by_log_pre:
				"But first - please log in the system. By logging in, you agree to our ",
			by_log_title: "Privacy policy",
			by_log_post: ".",
			by_log_link: "/privacy",
			no_mission_strong: "You don't have a mission yet?",
			no_mission_pre: " Explore",
			no_mission_title: "our missions",
			no_mission_post: " and find the best one for you!",
			no_mission_link: "/games",
			withGoogle: "Log in with Google",
			anonymous: " Log in anonymously",
			terms_pre: "I read and agree with the ",
			terms_title: "General Terms and Conditions",
			terms_post: ", including the safety rules.",
			terms_link: "/terms",
			postrules_next: "Continue", //forward

			new_team: "Create a team",
			join_team: "Join a team",

			anon_new_name: "New name",
			anon_new_image: "New image",
			anon_confirm: "Confirm and continue",
			anon_back: "Back",

			recaptcha_pre: "If you don’t see our ",
			recaptcha_name: "reCAPTCHA",
			recaptcha_post: " above, ",
			recaptcha_getintouch: "contact us",
			recaptcha_end: ".",
		},
		new_join: {
			enter_game_code: "Enter game code",
			game_code_description:
				"You will find it in your email or on the game card.",
			game_code_placeholder: "ABCD1234",

			enter_session_code: "Enter session code",
			session_code_description: "You will find it at the session creator.",
			session_code_placeholder: "Qu357",

			enter_team_name: "Enter team name",
			team_name_description: "What will be the name of your superteam?",
			team_name_placeholder: "Team name",

			next: "Next",
			back: "Back",
			join: "Join",
			surrender: "Give up",
			copy_code: "Copy code",
			code_copy: "The code is copied!",

			invite_more:
				"You can invite more people to join your team with the key that you can see above.",
			invite_no_more: "No more players can join.",

			make_sure:
				"Make sure that your teammates have joined, and you are at the starting location, before you start the game.",

			start_game: "Start the game",
			start_game_confirm:
				"Make sure that your teammates have joined, and you are at the starting location, before you start the game. Ready to start the game?",
			leave_session: "Leave the session",
			starting_location: "Starting location",

			surrender_title: "Do you really want to give up?",
			surrender_multiple_leave_description:
				"Use this ONLY IF all players want to give up. If ONLY YOU want to leave the game, use the button “Leave the session”.",
			surrender_multiple_surrender_description:
				"If everyone wants to give up, enter your team name below.",
			surrender_single_gameover_description:
				"You are the only player in this game. If you want to give up, the game will be lost automatically. If you don’t have the opportunity to continue now, don’t hesitate to do it later.",
			surrender_single_surrender_description:
				"If you are sure that you want to give up – enter your team name below.",
		},
		tutorial: {
			intro: "Here is a quick tutorial, so you know what to expect.",
			expand: "Expand",
		},
		tutorial_overlay: {
			skip: "Skip Introduction",
			next: "Next",
			previous: "Back",
			none: {
				title: "Before you start the game",
				subtitle: "here is a short introduction into this game system",

				page_contains: "The page has several main components - ",
				strong1: "the riddle",
				comma: ", ",
				strong2: "the answer field",
				and: " and ",
				strong3: "the hints",
				if: ", if any.",
				strong4: "The riddle",
				page_contains2:
					" contains information about where you need to go and what you need to find there to move forward in the game.",
			},
			riddle: {
				title: "The riddle",
				subtitle: "is the main part of the page.",
				each_riddle:
					"Each riddle is at a new location, so first figure out where you need to go to successfully solve it.",
				once_there:
					"Once you are in the right place - look carefully around you - this is the only way you will be able to find the answer.",
			},
			input: {
				title: "The answer field",
				subtitle: "is located near the bottom",
				some_enough:
					"For some riddles, entering numbers or words will be enough to proceed. Other riddles may require you to list multiple answers one after another.",
				some_exceptional:
					"For some riddles, the answer field is gone - instead you have to correctly complete a puzzle, enter symbols or scan a QR code, for example.",
			},
			hints: {
				title: "There are also hints",
				subtitle: "to some of the riddles.",
				cost: "They, however, can cost you points from the final score, so think before using them.",
				slide: "To unlock a hint, slide the key to the padlock.",
			},
			header: {
				title: "In addition, ",
				subtitle: "you have 3 buttons at the top.",
				xmark:
					"You can use this one if you want to quit the game or the whole team wants to quit.",
				question:
					"If the hints do not help or you need additional information - here you will find our contacts.",
				language:
					"You can also change the language of the game system at any time without changing the language of the game.",
			},
			footer: {
				title: "At the very bottom",
				subtitle: "is where you find the join code.",
				invite:
					"With it you can invite more players to join your team, even after the game has already been started.",
			},
			all: {
				title: "That's all! ",
				subtitle: "Adventure awaits you.",
				lets_go: "Let's get started!",
			},
		},
		message: {
			google_login_error:
				"An error occurred with your Google login. Please try again later.",
			game_inactive_error: "The game is not active at the moment.",
			game_not_found_error: "A game with this code has not been found.",
			new_game_created_check:
				"A new session was successfully created. Use the code to invite more teammates or continue by yourself.",
			game_already_over_error: "We are sorry, the game has already ended.", //(или is already over?)
			activation_code_used_error:
				"This code has already been used by another user.",
			activation_code_used_can_join_error:
				"This code has already been used by another user but you can still join – just ask them for the access key.",
			activation_code_use_limit_error:
				"This code has already reached the number of uses limit.",
			player_limit_error:
				"The player limit has been reached. No more players can join the game.",
			default_error: "An error occurred. Error code - ",
			default_error_end: "A session with this join code could not be found. Please check UPPERCASE and lowercase letters in the code. If the problem persists - refresh the page and try again.",
			default_okay: "Okay",
		},
		game: {
			skippable_riddle_title: "This riddle could be skipped",
			skippable_riddle_description:
				"If you have technical dificulties completing this riddle, you can skip it and move forward in the game.",
			skippable_riddle_skip: "Skip the riddle",
			skippable_riddle_skip_confirmation:
				"Are you sure you want to skip the riddle?",
			skippable_riddle_skip_message: "You've skipped the riddle",
			// —
			bonus_riddle_title: "Congratulations, you found a bonus riddle!",
			bonus_riddle_description:
				"Bonus riddles are harder and have no hints. No points will be lost, if you decide to skip that.",
			bonus_riddle_skip: "Skip the bonus riddle",
			bonus_riddle_skip_confirmation:
				"Are you sure you want to skip the bonus riddle?",
			bonus_riddle_skip_message: "You've skipped the bonus riddle",
			header: {
				surrender_title: "Give up",
				help_title: "Help",
				lang_title: "Change language",
			},
			aside: {
				button: "Enter",
				button_check: "Check",
				button_reset: "Reset",
				button_backspace: "Delete",
				answer_revealed: "Revealed answer",
				answer_hidden: "Hidden answer",
				has_hints: "This riddle has hints.",
				has_hints_description: "Using hints might cost you some points.",
				slide_to_unlock: "Slide the key to the lock to reveal the hint.",
				hint_confirmation:
					"Are you sure you want to open a hint?\nUsing hints may cost you points.",
			},
			riddle: {
				multiple_all_message: "Great work! Ready for the next riddle?",
				multiple_all_action: "More than ready!",
				multiple_more_message:
					"Great work so far! Let's find the next answer, shall we?", //"Correct! Let's find the next answer.",
				multiple_more_action: "We shall!",
				multiple_repeat_message:
					"This answer is correct. So correct, in fact, you've already said it.",
				multiple_repeat_action: "I'll try again!",
				multiple_wrong_message: "Ready or not - that answer was wrong 😭",
				multiple_wrong_action: "Let's try again!",
				single_message: "Correct! Ready for the next riddle?",
				single_action: "Let's go!",
				wrong_message: "Um.. not sure how to say this... that's wrong 😢",
				wrong_action: "I'll try again! 💪",
				default_action: "Okay", //Default Okay [193]
				could_not_locate:
					"The current riddle couldn't be located on the system. Please contact an admin.",
				not_too_fast:
					"Not too fast! Read the riddle carefully and then try to answer.",
			},
			qr: {
				scan_btn: "Scan QR code",
				qr_camera_disclaimer:
					"Permission is required to use the camera. Information from your camera does not leave your device and is not stored anywhere.",
			},
			geolocked: {
				this_part: "This part is geographically locked.",
				visit_correct: "Navigate to the correct location to unlock it.",
				you_unlocked: "You successfully unlocked that part.",
				stay_around: "Stay close so it doesn't lock up again.",
				permission: "Use my location",
				disclaimer:
					"Permission is required to use your location. Your location data does not leave your device and is not stored anywhere.",
				tracking: "Tracking...",
				your_distance: "You are currently ",
				from_target: " away from the target.",
				closer_unlock: "Move closer to unlock.",
				error: "An error occured!",
				error_timeout: "The request could not be completed in the aloted time.",
				error_permission: "Missing permission to use the location.",
				error_unavailable: "The location cannot be determined.",
				error_browser: "Geolocation is not supported by this browser.",
			},

			footer: {
				vendor: "Inner Voice / Vutreshen Glas",
				powered_by: "Powered by",
				join_code: "Join code:",
			},
		},
		chat: { send: "Send", type_message: "Type a message...", send_image: "Send image", chat_header_title: "Chat", sending: "Sending...", uploaded_by: "Uploaded by ", input_disabled: "Sending messages is currently disabled." },
		help: {
			title: "You need help?",
			description: "Don't hesitate to contact us:",
			messenger: "Facebook Messenger",
			messenger_link: "https://m.me/vutreshenglas",
			instagram: "Instagram",
			instagram_link: "https://instagram.com/vutreshenglas",
			email: "quest@vutreshenglas.com",
			email_link: "mailto:quest@vutreshenglas.com",
		},
		conclusion: {
			share_how_to_be_better: "Help us improve.",
			send_review: "Send us your feedback",
			send_review_link:
				"mailto:feedback@vutreshenglas.com?subject=Mission feedback",
			back_home: "Back to the beginning",
			sorry_pre: "We are sorry, ",
			sorry_post: ", it looks like the game won.",
			sorry_description: "Better luck next time!",
			congrats_pre: "Congratulations, ",
			congrats_post: "! You completed the game!",
			congrats_description: "You were great with the riddles, way to go!",
			// congrats_description: 'You did well with the riddles, congratulations.',
			//https://www.thesaurus.com/e/ways-to-say/s/congratulations/#way-to-go

			your_time: "Your time",
			your_hints: "Hints used",
			your_score: "Your score",
			time: "Time",
			hints: "Hints",
			used_hint: "used hint",
			used_hints: "used hints",
			score: "Score", //or Points
			point: "point",
			points: "points",
			see_leaderboard: "See leaderboard",
			share_your_score: "Share your score", //or Result
			download_share: "Download and Share",
			completed_the_mission: "completed the mission",
			generating: "Generating image ...",
		},
		map: {
			map_header_title: "Map",
			//
			error_no_browser_support: "Geolocation is not supported by this browser.",
			error_permission_denied:
				"An error occurred - permission to use geolocation was denied.",
			error_position_unavailable:
				"An error occurred - location data is unavailable.",
			error_timeout:
				"An error occurred - The request to get user location timed out.",
			error_uknown_error:
				"An unknown error occurred - the location could not be determined.",
			error_generic:
				"An error occurred - the location could not be determined.",
			//
			outside_of_play_area: "You are outside the play area.",
			go_east: "Please head east.",
			go_west: "Please head west.",
			go_north: "Please head north.",
			go_south: "Please head south.",
			go_se: "Please head southeast.",
			go_sw: "Please head southwest.",
			go_ne: "Please head northeast.",
			go_nw: "Please head northwest.",
		},
		panel: {
			scan_qr_pre: "Scan the code to join ",
			scan_qr_post: "and play with friends!"
		},

		// order: {
		//     success: {
		//         page_title: 'SUCCESS',
		//         title: 'Here comes the title in EN',
		//         content_md: 'Check your email for your game code and begin your adventure on vutreshenglas.com/game.'
		//     },
		//     cancel: {
		//         page_title: 'CANCEL',
		//         title: 'Here comes the title in EN',
		//         content_md: 'Check your email for your game code and begin your adventure on vutreshenglas.com/game.'
		//     }

		// }
	},

	// en: {
	//     global: {
	//         loading: "loading... 0000",
	//         log_out: 'Sign out',
	//         time: {
	//             minute: 'min'
	//         }
	//     },
	//     game: {
	//         aside: {
	//             button: 'Enter',
	//         },
	//         footer: {
	//             vendor: 'Inner Voice / Vutreshen Glas',
	//             powered_by: 'Powered by'
	//         }
	//     }
	// },
	// fr: {
	//     global: {
	//         loading: "le loadinge 9876...",
	//         logOut: 'Exité'
	//     }
	// }
};

export function uiText(lang) {
	if (lang == "bg") {
		return uiTextData.bg;
		// } else if (lang == 'fr') {
		//     return uiTextData.fr;
	} else {
		return uiTextData.en;
	}
}
